module.exports = __webpack_public_path__ + "img/IMG_9621_L_Foamcore_MockedUp.638e9417.jpg";